export const INTERPRETER_LANGUAGES = [
  { code: 'spanish', label: 'Spanish' },
  { code: 'mandarin', label: 'Mandarin' },
  { code: 'portuguese', label: 'Portuguese' },
  { code: 'french', label: 'French' },
  { code: 'arabic', label: 'Arabic' },
  { code: 'vietnamese', label: 'Vietnamese' },
  { code: 'korean', label: 'Korean' },
  { code: 'russian', label: 'Russian' },
  { code: 'other', label: 'Other' },
] as const;

export function getInterpreterLanguageLabel(code: string): string {
  return INTERPRETER_LANGUAGES.find(l => l.code === code)?.label ?? code;
}
